import { createContext } from 'react';

type Stack = string[];

export interface ScreenContextState {
	readonly active: string | null;
	readonly screens: Set<string>;
	readonly protectedScreens: Set<string>;
	readonly screenStack: Readonly<Stack>;
	readonly target: string | undefined;
	activate(link: string): void;
	dismiss(): void;
}

export const ScreenContext = createContext<ScreenContextState>(undefined as unknown as ScreenContextState);
